import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import usePermissions from "../hooks/usePermissions";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../Loader/loader";
import TableLoader from "../../Loader/TableLoader";
import Swal from "sweetalert2";

const ManageSeoPage = () => {
  const { canCreate, canEdit, canDelete } = usePermissions("/cms/manageseopage");

  const [seoPage, setSeoPage] = useState();
  const [token, setToken] = useState(localStorage.getItem("cms_token"));
  const [status, setStatus] = useState(0);
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    setToken(localStorage.getItem("cms_token"));
    loadContent();
  }, []);

  const loadContent = async () => {
    setIsLoading(true)
    await axios
      .get(`${API_BASE_URL}/get-seo-list`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "content-type": "multipart/form-data",
        },
      })

      .then((response) => {
        // console.log(response.data,"response")
        setSeoPage(response.data.msg.reverse());
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false)
        console.log(error);
      });
  };

  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        let body ={
          id : id,
          delete_for : 'seo'
        }
        axios
          .post(`${API_BASE_URL}/delete-tabuler-data`,body, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          })
          .then((response) => {
            if (response.data.status === 200) {
              Swal.fire("Deleted!", "Your file has been deleted.", "success");
              axios

                .get(`${API_BASE_URL}/get-seo-list`, {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                })
                .then((response) => {
                  setSeoPage(response.data.msg.reverse());
                })
                .catch((error) => {
                  console.log(error);
                });
            }
          });
      }
    });
  };

  const handleActive = async (status, id) => {
    let updatedStatus = status == 0 ? 1 : 0;
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${updatedStatus == 1 ? 'Activate' : 'Deactivate'} this ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, do it!",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true)
        axios.post(
          `${API_BASE_URL}/update-seo-status`,
          { status: updatedStatus, id: id },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
          .then((response) => {
            const res = JSON.parse(JSON.stringify(response));
            if (res.data.status === 200) {
              setIsLoading(false)
              loadContent();
              if (status == 1) {
                toast.success("Inactive successfully");
              } else {
                toast.success("Active successfully");
              }
            }
            else{
              setIsLoading(false)
            }
          })
          .catch((error) => {
            setIsLoading(false)
            console.log(error);
          });
      }
    });
  };

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">Manage SEO Page </h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="javascript: void(0);">CMS</a>
                      </li>
                      <li className="breadcrumb-item active">
                        Manage SEO Page
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row justify-content-end">
              <div className="col-lg-12 mb-2 ">
                <Link
                  to={"/cms/manageseopage/addseopage"}
                  data-repeater-create
                  type="button"
                  className="btn btn-success inner"
                  value="Add Number"
                >
                  Add <i className="fa fa-plus ms-1"></i>
                </Link>
              </div>
            </div> */}

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                  <h4 className="card-title">
                      SEO Page List ({seoPage?.length})
                    </h4>
                    {canCreate && (
                    <Link
                      to={"/cms/manageseopage/addseopage"}
                      data-repeater-create
                      type="button"
                      className="btn btn-success inner"
                      value="Add Number"
                    >
                      Add <i className="fa fa-plus ms-1"></i>
                    </Link>
                    )}
                  </div>
                   
                    {/* {isLoading ? (
                      <Loader />
                    ) : ( */}
                    <div className="table-responsive">
                      <table className="table align-middle table-nowrap mb-0">
                        <thead className="table-light">
                          <tr>
                            {/* <th styles="width: 20px;">
                              <div className="form-check font-size-16 align-middle">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="transactionCheck01"
                                />
                                <label
                                  className="form-check-label"
                                  for="transactionCheck01"
                                ></label>
                              </div>
                            </th> */}
                            <th className="align-middle">Page id</th>
                            <th className="align-middle">Page Name</th>
                            <th className="align-middle">Page URL</th>
                            <th className="align-middle">Meta Title</th>
                            {/* <th className="align-middle">Meta keywords</th> */}
                            {/* <th className="align-middle">Description</th> */}
                            <th className="align-middle">Status</th>
                            <th className="align-middle">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          { isLoading ? 
                          <TableLoader count={5} /> : 
                          seoPage?.length > 0 ?
                          (seoPage?.sort((a, b) => a.page_id - b.page_id)?.map((item, index) => (
                            <tr key={index}>
                              {/* <td>
                                <div className="form-check font-size-16">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="transactionCheck02"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="transactionCheck02"
                                  ></label>
                                </div>
                              </td> */}
                              <td>
                                <a
                                  href="javascript: void(0);"
                                  className="text-body fw-bold"
                                >
                                  {item.id}
                                </a>
                              </td>
                              <td>{item.page_name}</td>
                              <td>{item.page_url}</td>
                              <td>{item.meta_title}</td>

                              {/* <td> */}
                              {/* {item.meta_keywords} */}
                              {/* <span className="badge badge-pill badge-soft-success font-size-11">
                              
                              </span> */}
                              {/* </td> */}

                              <td>
                                {item.status == 1 ? (
                                  <span className="badge badge-pill badge-soft-success font-size-11">
                                    Active
                                  </span>
                                ) : (
                                  <span className="badge badge-pill badge-soft-danger font-size-11">
                                    Inactive
                                  </span>
                                )}
                              </td>

                              <td>
                                {canEdit && (
                                <Link
                                  to={`/cms/manageseopage/editseopage/${item.id}`}
                                  type="button"
                                  className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                >
                                  <i className="fa fa-pen"></i>
                                </Link>
                                )}
                                {canDelete && (
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm btn-rounded waves-effect waves-light ms-2"
                                  onClick={() => {
                                    handleDelete(item.id);
                                  }}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                                )}

                                <button
                                  type="button"
                                  className="btn btn-warning btn-sm btn-rounded  ms-2"
                                  onClick={() => {
                                    handleActive(item.status, item.id);
                                  }}
                                >
                                  <i className="fa fa-ban"></i>
                                </button>
                              </td>
                            </tr>
                          ))) : 
                          (
                            <tr>
                              <td colSpan="11">
                                <div
                                  style={{
                                    textAlign: "center",
                                    fontSize: "18px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  No Data Found
                                </div>
                              </td>
                            </tr>
                          )
                        }
                        </tbody>
                      </table>
                    </div>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageSeoPage;
